import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWolframComponent } from './simple-icons-wolfram.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWolframComponent ],
    exports:      [ SimpleIconsWolframComponent ],
    bootstrap:    []
})
export class SimpleIconsWolframModule {}
